// @flow
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { CheckoutButton } from 'app/common/layouts/commonShop';
import ConfirmationDialog from 'app/common/components/Confirmation/ConfirmationDialog';
// $FlowFixMe
import { orderCancel } from 'app/common/actions/shop/order/cancel';

import { type OrderType } from '../../OrderData';


/**
 * Отмена заказа
 */

type Props = {
  id: string,
  number: string,
  className?: string,
  onUpdateOrder?: (order: OrderType) => void,
}

const OrderCancelButton = ({
  id,
  number,
  className,
  onUpdateOrder,
}: Props) => {
  const dispatch = useDispatch();

  const handleCloseOrder = useCallback(async () => {
    const newOrder = await dispatch(orderCancel(id));
    if (newOrder && onUpdateOrder) {
      onUpdateOrder(newOrder);
    }
  }, [dispatch, id, onUpdateOrder]);

  return (
    <ConfirmationDialog
      onConfirm={handleCloseOrder}
      text={`Отменить заказ №${number}`}
      confirmButtonText="Отменить"
    >
      {handleConfirm => (<CheckoutButton
        className={className}
        onClick={handleConfirm}
        outline
      >
        {'Отменить заказ'}
      </CheckoutButton>)}
    </ConfirmationDialog>
  );
};

export default OrderCancelButton;
